<template>
  <section :class="{'left':true, 'bgcolor-6':!principal}">
    <template v-if="principal">
      <!-- <a>
        <i @click="seleccion = true; principal = false; $store.state.ocultarBarra = true;" class="icon-cursor color-6"></i>
      </a> -->
      <a class="btnTools">
        <i @click="Dibujar(); $store.state.ocultarBarra = true;" class="icon-shapes color-6"></i>
      </a>
      <a class="btnTools">
        <i @click="AgregarTexto()" class="icon-type color-6"></i>
      </a>
      <a class="btnTools">
        <i @click="ZonaActiva()" class="icon-clip-dot color-6"></i>
      </a>
      <!-- <a>
        <i @click="figura =  true; principal = false" class="icon-masking color-6"></i>
      </a> -->
      <a class="btnTools">
        <i @click="$store.state.modalCronograma = true" :style="{'margin-top':  $store.state.isMobile?'6px':'none', 'top':'0px'}" class="font-times color-6"></i>
      </a>
      <a :class="{'btnTools':true, 'selected':selectedCrop}">
        <i @click="openCropper" style="top:0px; font-size:35px!important" class="fa fa-crop-alt color-6"></i>
      </a>
    </template>
    <template v-else>
      <a
        id="Regresar"
        @click="principal = true; inicial()"
        style="box-shadow: rgba(0, 0, 0, 0.5) 4px 0px 6px -2px;background:#3c3c3b"
      >
        <i class="icon-arrow-up color-6"></i>
      </a>
      <Seleccion v-if="seleccion"></Seleccion>
      <Dibujar v-if="dibujar"></Dibujar>
      <!-- <Texto v-if="texto"></Texto> -->
      <ZonaActiva v-if="zona"></ZonaActiva>
      <!-- <Figuras  v-if="figura"></Figuras> -->
    </template>
  </section>
</template>

<script>
import Seleccion from "./Seleccion";
import Dibujar from "./Dibujar";
// import Texto from "./Texto";
import ZonaActiva from "./ZonaActiva";
// import Figuras from "./Figuras";
import { mapMutations } from 'vuex'

import $ from "jquery";

export default {
  name: "Herramientas",
  components: {
    Seleccion,
    Dibujar,
    // Texto,
    ZonaActiva,
    // Figuras
  },
  data: () => ({
    principal: true,
    seleccion: false,
    dibujar: false,
    // texto: false,
    zona: false,
    selectedCrop: false
    // figura: false,
  }),
  methods: {
    inicial() {
      this.$store.state.isModeActiveZone = false;
      this.seleccion = false;
      this.dibujar = false;
      // this.texto = false;
      this.zona = false;
      // this.figura = false;
      let viewer = $('#pageLM')
      viewer.off();
      $('body').removeClass("kinetic");
      $('#viewer').css('cursor','auto');
      $('aside').css('cursor','auto');
      $('#contenedorZona_1').css('height', $('#pageImgOne').height() + 'px')
      $('#contenedorZona_1').css('width', $('#pageImgOne').width() + 'px')
      $('#contenedorZona_2').css('height', $('#pageImgOne').height() + 'px')
      $('#contenedorZona_2').css('width', $('#pageImgOne').width() + 'px')
      this.ActivarNavegacion()
      $('.contUrlGoAddBtnLink-cerrar').css('display', 'none');
      $('.zonaTransparenteFlag').removeClass('zonaTransparente');
      this.$store.state.ocultarBarra = false;
      this.$store.state.typeResource = '';
      this.$store.state.openHZone = false;
    },
    openCropper(){
      
      if(!this.selectedCrop){
        this.$store.state.ocultarBarra = true;
        $('.btnTools').addClass('disabled')
      } else {
        $('.btnTools').removeClass('disabled')
        this.$store.state.ocultarBarra = false;
      }
      
      this.selectedCrop = !this.selectedCrop;
      this.setCropper(this.selectedCrop);
    },
    Dibujar(){
      this.dibujar =  true; 
      this.principal = false;
      $('#contenedorZona_1').css('height','0px')
      $('#contenedorZona_1').css('width','0px')
      $('#contenedorZona_2').css('height','0px')
      $('#contenedorZona_2').css('width','0px')
      $('body').addClass("kinetic");
      this.DesactivarNavegacion();
    },
    ZonaActiva(){
      this.zona =  true; 
      this.principal = false; 
      this.$store.state.ocultarBarra = true;
      this.$store.state.openHZone = true;
      this.setTypeModalResource("typeResourceEdit")
      this.DesactivarNavegacion();
      $('.contUrlGoAddBtnLink-cerrar').css('display', 'block');
      $('.zonaTransparenteFlag').addClass('zonaTransparente');
    },
    ActivarNavegacion(){
      //Se activa la navegacion
      $('.btnPaginationLeft').removeClass('isInactiveCanvas');
      $('.btnPaginationRight').removeClass('isInactiveCanvas');
      $(".inputPagination").prop('disabled', false);
      $("#btnPages").removeClass('isInactiveCanvas');
      $(".contBtnUnits").removeClass('isInactiveCanvas');
      $(".pestana").removeClass('pestanaDesactivadaCanvas');
    },
    DesactivarNavegacion(){
      //Se desactiva la navegacion
      $('.btnPaginationLeft').addClass('isInactiveCanvas');
      $('.btnPaginationRight').addClass('isInactiveCanvas');
      $(".inputPagination").prop('disabled', true);
      $("#btnPages").addClass('isInactiveCanvas');
      $(".contBtnUnits").addClass('isInactiveCanvas');
      $(".pestana").addClass('pestanaDesactivadaCanvas');
    },
    AgregarTexto(){
      this.$store.state.typeResource = 'note';
      $('#viewer').css('cursor', 'crosshair');
      $('aside').css('cursor', 'crosshair');
    },
    ...mapMutations(['setCropper', 'setTypeModalResource'])
  }
};
</script>

<style>
  .btnTools.disabled i{
    opacity: 0.7; 
  }

  .btnTools.selected i{
    color: #ff7900;
    opacity: 1 !important; 
  }
</style>